// extracted by mini-css-extract-plugin
export default {"content":"content-uaC3Ch_s","leftColumn":"leftColumn-r0oU4eYj","rightColumn":"rightColumn-hMVg1Eol"};